import { LayoutProps, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutP44Control } from "./autogen/AutogenLayoutP44Control";

interface P44ControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class P44Control extends AutogenLayoutP44Control {

    constructor(props?: Partial<P44ControlLayoutProps>) {
        super(props);
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("id", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    textboxP44ProfileIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.config_type = "N";
    }
}
